import React, {useEffect} from 'react'

const EmployerBooking = () => {
    useEffect(() => {
        const head = document.querySelector("head");
        const script = document.createElement("script");
        script.setAttribute(
          "src",
          "https://assets.calendly.com/assets/external/widget.js"
        );
        head.appendChild(script);
    }, [])

    return (
        <div>
            <div className="calendly-inline-widget" data-url="https://calendly.com/wedevelopers/build-your-product?primary_color=27336d" style={{minWidth:"320px", height:"630px"}}></div>
        </div>
    )
}

export default EmployerBooking
